<template>
  <el-card shadow="never" class="aui-card--fill">
    <vxe-toolbar ref="xToolbar" custom>
      <template v-slot:buttons>
        <el-form
          :inline="true"
          :model="queryForm"
          @keyup.enter.native="getDataList()"
          ref="queryForm"
          class="query-form"
        >
          <el-form-item prop="sellerName" label="外销合同号：">
            <el-input
              v-model="queryForm.orderCode"
              size="mini"
              clearable
              type="text"
              placeholder="请输入外销合同号"
            ></el-input>
          </el-form-item>
          <el-form-item prop="storeName" label="仓库：">
            <el-input
              v-model="queryForm.storeName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入仓库名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="productName" label="品名：">
            <el-input
              v-model="queryForm.productName"
              size="mini"
              clearable
              type="text"
              placeholder="请输入品番号/品名/颜色/规格"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDataList" size="mini"
              >查询</el-button
            >
            <el-button @click="reset" size="mini">重置</el-button>
            <el-button type="warning" size="mini" @click="$refs.commonUpload.init()"
        >入库数据导入</el-button
        >
          </el-form-item>
        </el-form>
      </template>
    </vxe-toolbar>
    <vxe-table
      align="center"
      :id="tableConfig.id"
      :ref="tableConfig.tableName"
      show-overflow
      row-id="id"
      :height="tableConfig.height"
      :loading="tableData.loading"
      :data="tableData.dataList"
      :cell-style="cellStyleHandler"
      :custom-config="{ storage: true, checkMethod: checkColumnHandler }"
      @resizable-change="resizableChangeEvent"
    >
      <vxe-column type="seq" title="行号" width="50"></vxe-column>
      <vxe-column
        field="agreementCode"
        title="合同编号"
        min-width="160"
        :formatter="companyNameFormatter"
      ></vxe-column>
      <vxe-column
        field="storageName"
        title="仓库名称"
        :formatter="companyNameFormatter"
        min-width="160"
      ></vxe-column>
      <vxe-column field="code" title="品番号" min-width="90"></vxe-column>
      <vxe-column field="name" title="品名" min-width="90"></vxe-column>
      <vxe-column field="color" title="颜色" min-width="90"></vxe-column>
      <vxe-column field="size" title="规格" min-width="90"></vxe-column>
      <vxe-column field="count" title="库存数量" min-width="90" fixed="right">
        <template #default="{ row }">
          <el-tag :type="row.count > 0 ? 'success' : 'danger'"
            >{{ row.count }}
          </el-tag>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager
      :loading="tableData.loading"
      :current-page="tableData.currentPage"
      :page-size="pagerConfig.pageSize"
      :total="tableData.total"
      :layouts="pagerConfig.layouts"
      @page-change="vxePageChanger"
    >
    </vxe-pager>
    <common-upload
        ref="commonUpload"
        @success="uploadSuccessHandler"
        uploadUrl="/store/product/import/checkin"
        templateUrl="/static/template/箱单导入模板.xlsx"
        title="入库数据导入"
    ></common-upload>
  </el-card>
</template>

<script>

import VxeTable from "@/mixins/vxe-table";

export default {
  mixins: [VxeTable],
  components: {},
  data() {
    return {
      tableConfig: {
        queryUrl: "/store/page",
      },
      queryForm: {
        productType: "产品",
        productName: "",
        orderCode: "",
        storeName: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    uploadSuccessHandler(){
      this.reload()
    }
  },
};
</script>

<style scoped></style>
